var map = {
	"./assemble_01.jpg": 7199,
	"./assemble_02.jpg": 4218,
	"./assemble_03.gif": 9603,
	"./assemble_04.jpg": 3278,
	"./bake_01.jpg": 556,
	"./bake_02.jpg": 3182,
	"./bake_03.jpg": 6777,
	"./filling_01.jpg": 6966,
	"./filling_02.jpg": 6132,
	"./filling_03.jpg": 8323,
	"./sauce_01.jpg": 2155,
	"./sauce_02.jpg": 5907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3562;